<div class="container">
  <ng-lottie width="100px" height="100px" [options]="options"></ng-lottie>
  <div class="text">
    <h1>¡Listo!</h1>
    <span>Ya puedes iniciar sesión en Globot.</span>
  </div>
  <a class="btn-login" href="/dashboard/login">Ir a inicio de sesión</a>
</div>
